module.exports = __webpack_public_path__ + "img/img-syzx.17a03b02.png";